import { ModuleWithProviders, NgModule } from '@angular/core';

import { provideGoogleTagManagerInitializer } from './initializers/google-tag-manager.initializer';
import { IGoogleTagManagerConfig } from './interfaces/i-google-tag-manager-config';
import { GOOGLE_TAG_MANAGER_CONFIG_TOKEN } from './tokens/google-tag-manager-config-token';

@NgModule({
  declarations: [],
  imports: [],
})
export class GoogleTagManagerModule {
  static forRoot(trackingCode: string): ModuleWithProviders<GoogleTagManagerModule> {
    return {
      ngModule: GoogleTagManagerModule,
      providers: [
        {
          provide: GOOGLE_TAG_MANAGER_CONFIG_TOKEN,
          useValue: {
            trackingCode,
          } as IGoogleTagManagerConfig,
        },
        provideGoogleTagManagerInitializer(),
      ],
    }
  }
}
